import { render, staticRenderFns } from "./FoundResults.vue?vue&type=template&id=2f158358&scoped=true"
import script from "./FoundResults.vue?vue&type=script&lang=ts"
export * from "./FoundResults.vue?vue&type=script&lang=ts"
import style0 from "./FoundResults.vue?vue&type=style&index=0&id=2f158358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f158358",
  null
  
)

export default component.exports